import { LongTermOptionsActions } from './actions'
import { LongTermOptionsGetters } from './getters'
import { LongTermOptionsMutations } from './mutations'
import { LongTermOptionsState } from './state'

export const LONG_TERM_OPTIONS_NAMESPACE = 'longTermOptions'

export const LongTermOptions = {
  namespaced: true,
  state: LongTermOptionsState,
  actions: LongTermOptionsActions,
  mutations: LongTermOptionsMutations,
  getters: LongTermOptionsGetters,
}
